import { validateField } from "@/lib/formValidation";
import { Label } from "@radix-ui/react-label";
import {
  Root,
  Item as RadioGroupItem,
  Indicator,
} from "@radix-ui/react-radio-group";
import { ErrorMessage, Field, useField } from "formik";
import { Fragment } from "react";
import { Icon } from "../Icon";
import s from "./RadioGroup.module.css";

const Item = ({ children, value, className = "" }) => {
  return (
    <div className={`flex mr-2 mb-2 ${className}`}>
      <RadioGroupItem
        value={value}
        id={value}
        className="unset bg-gray-100 rounded-full border-full shadow w-[25px] h-[25px] mr-4"
      >
        <Indicator className="w-full h-full after:w-[11px] after:h-[11px] after:rounded-full flex items-center justify-center after:content-[' '] after:bg-success" />
      </RadioGroupItem>
      <Label
        htmlFor={value}
        className="text-gray-600 text-base disabled:bg-gray-100"
      >
        {children}
      </Label>
    </div>
  );
};

const RadioGroup = ({ children, className = "", ...props }) => {
  return (
    <Root className={className} {...props}>
      {children}
    </Root>
  );
};

export default Object.assign(RadioGroup, { Item });

export const Typo3RadioGroup = ({
  properties,
  defaultValue,
  name,
  ...props
}) => {
  const [field, meta, helpers] = useField(`['${name}']`);
  const layout =
    properties?.gridColumnClassAutoConfiguration?.viewPorts?.lg
      ?.numbersOfColumnsToUse === "4"
      ? "vertical"
      : "horizontal";

  // return (
  //   <RadioGroup
  //     value={field.value}
  //     onValueChange={(value) => helpers.setValue(value)}
  //   >
  //     {Object.entries(properties.options).map(([value, label]) => (
  //       <Item value={value} key={value}>
  //         {label}
  //       </Item>
  //     ))}
  //   </RadioGroup>
  // );

  return (
    <div
      className={`form-control flex flex-col  ${
        layout != "vertical" && "py-4 container"
      }
      ${layout === "vertical" && "!py-8 ml-[-10px] lg:ml-[-6px]"}
      `}
    >
      {props.label && (
        <div className="text-blue-dark font-bold lg:py-8 py-5 lg:text-3xl text-2xl">
          <label htmlFor="">{props.label}</label>
        </div>
      )}
      <div
        className={`flex flex-row flex-wrap ${
          layout === "vertical" && "lg:!flex-nowrap lg:gap-0 gap-6 "
        }`}
      >
        <Field
          name={`['${name}']`}
          {...props}
          validate={(value) => validateField(value, props.validators)}
        >
          {({ field, meta }) => {
            return Object.entries(properties.options).map(([value, label]) => {
              return (
                <Fragment key={value}>
                  <div
                    className={`${
                      layout === "vertical" && " flex flex-row gap-4"
                    }`}
                  >
                    <input
                      type="radio"
                      id={value}
                      {...field}
                      value={value}
                      checked={field.value === value}
                      className="mx-4 accent-blue-light"
                    />
                    <label
                      className="mr-8 lg:text-3xl text-base"
                      htmlFor={`${label}`}
                    >
                      {label as any}
                    </label>
                  </div>
                </Fragment>
              );
            });
          }}
        </Field>
        <ErrorMessage component={TextError} name={name} />
      </div>
      {meta.touched && meta.error && (
        <div
          className={` ${
            meta.error ? "text-alert" : "text-success"
          } whitespace-nowrap`}
        >
          <Icon type="attention" className="md:w-[16px] w-9 inline-flex mr-4" />
          <span className="">{meta.error}</span>
        </div>
      )}
    </div>
  );
};

const TextError = (props) => {
  return <div>{props.children}</div>;
};
